import { Component, OnInit, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { Subscription, ArgumentOutOfRangeError } from 'rxjs';
import { UserService, AuthenticationService } from '../_services';
import { LocalStorageService } from 'angular-web-storage';
import { ProductsService } from '@app/products/products.service';
import { CustomersService } from '@app/customers/customers.service';
import { ReportingService } from '@app/reporting/reporting.service';
import { TransactionsService } from '../sales/transactions/transactions.service';
import { ReplaySubject, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
// import { MatTableDataSource, PageEvent, MatPaginator, MatDatepickerInputEvent } from '@angular/material';
import { DataService } from '@app/_services/data.service';
import { MatTableDataSource, MatDatepickerInputEvent, PageEvent, MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SearchService } from '@app/_services/search/search.service';
import { ConfirmationDialogService } from '@app/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { NominalAccountsService } from '@app/nominal-accounts/nominal-accounts.service';

enum TransactionsElement {
  transaction_id,
  type,
  total,
  payment,
  customer_id, customer_name,
  store_id, store_name,
  transaction_date,
  user_id, user_name, total_margin, total_percent_margin
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  currentUser: any; total_sales; total_customers; total_products; todays_sales; report_for; headings; records; summary;
  period; product; customer; representative; report; report_title; print_date = new Date();
  which_period; from = new Date(); to = new Date(); day; month; year; date_f = new Date(); years;
  report_from; report_to; products_report = 0;
  csr_from; csr_to; sort_by; order_by; products_by_sale;
  selected_customer; sales_period = false;
  queryField: FormControl = new FormControl();
  protected customers: any[];
  summary_of_sales; dialogOpened = false;
  predefined = false; model; id; submitted = false; errorInPhone = false; transactions; date;
  loaded = false;
  //////////////////////////////////
  showdd1 = false;
  showDeleteButton = false;
  length;
  currentUserSubscription;
  store_id; break_down = false;
  pageSize = 10;
   pageIndex; pageEvent: PageEvent;
  
  @Output() page: EventEmitter<PageEvent>;
  selectedAccounts;
  displayMonths = 2;
  navigation = 'select';
  showWeekNumbers = false;
  outsideDays = 'visible';

  /** control for the selected customer for multi-selection */
  public customerMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public customerMultiFilterCtrl: FormControl = new FormControl();

  public searching: boolean = false;
  /** list of customers filtered by search keyword */
  public filteredCustomersMulti: ReplaySubject<any> = new ReplaySubject<any>(1);
  protected representatives: any[];

  /** control for the selected customer for multi-selection */
  public representativeMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public representativeMultiFilterCtrl: FormControl = new FormControl();

  /** list of customers filtered by search keyword */
  public filteredRepresentativesMulti: ReplaySubject<any> = new ReplaySubject<any>(1);
  protected products: any;

  /** control for the selected customer for multi-selection */
  public productMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public productMultiFilterCtrl: FormControl = new FormControl();

  /** list of customers filtered by search keyword */
  public filteredProductsMulti: ReplaySubject<any> = new ReplaySubject<any>(1);
  daysOfTheWeek: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];
  monthsOfTheYear: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  constructor(
    public local: LocalStorageService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private productsService: ProductsService,
    private customersService: CustomersService,
    private transactionService: TransactionsService,
    private reportingService: ReportingService,
    private dataService: DataService,
    public dialog: MatDialog,
    private searchService: SearchService,
    private confirmationDialogService: ConfirmationDialogService,
    private toasterService: ToastrService, private nominalService: NominalAccountsService,

  ) {
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
    this.date = new Date();
  }
  getColumnName(inp): string {
    if (inp == "transaction_type") return "Transaction Category";
    if (inp == "transaction_id") return "Transaction ID";
    if (inp == "track_description") return "Account Name";
    if (inp == "ntt_type") return "Transaction Type"; ///////////
    if (inp == "amount") return "Amount";
    if (inp == "description") return "For";
    if (inp == "store_name") return "Store Name";
    if (inp == "amount") return "Amount";
  }
  isAllSelected() {

  }
  applyFilter(filterValue: string) {
  }

  prints() {
    var data = document.getElementById("template_invoice").innerHTML;
    var html = "<html>";
    html += "<head>";
    html += "<style>@media print{@page{size:auto;size: A4 portrait;margin-top: 0%;margin-bottom: 0%;margin-left: 0%;margin-right: 0%;border: 1px solid red;orphans:5; widows:4;}@page :nth(2) body{orphans:5; widows:4;margin-top:5%}</style>"
    html += "<style>@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,700&subset=cyrillic,cyrillic-ext,latin,greek-ext,greek,latin-ext,vietnamese);a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h2,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;font-size:100%;vertical-align:baseline}html{line-height:1}ol,ul{list-style:none}{border-collapse:collapse;border-spacing:0}caption,td,th{text-align:left;font-weight:400;vertical-align:middle}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}a img{border:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}.clearfix{display:block;clear:both}.hidden{display:none}.bold,b,strong{font-weight:700}#template_invoice{height:auto;overflow:auto;width:21cm;padding:.5cm;margin:.2cm auto;border:1px #d3d3d3 solid;border-radius:5px;background:#fff;box-shadow:0 0 5px rgba(0,0,0,.1)}#container{height:fit-content;font:normal 13px/1.4em 'Open Sans',Sans-serif;margin:5px 5px;padding:5px 5px;min-height:26cm;max-height:fit-content}#memo .company-name{background:#fff 560px center no-repeat;background-size:100px auto;display:inline-block;margin-bottom:25px;padding:5px 0 5px 0}#memo .company-name span{color:#1dafec;display:inline-block;min-width:20px;font-size:75px;font-weight:700;line-height:1em}#memo .company-name .right-arrow{position:absolute;top:0;right:0;bottom:0;width:100px;background:right center no-repeat;background-size:auto 60px}#memo .logo{float:left;clear:left;margin-left:20px}#memo .logo img{width:150px;height:100px}#memo .company-info{float:right;text-align:right;display:inline-block;margin-left:20px;font-size:12px;color:#8b8b8b}#memo .company-info div{margin-bottom:5px;min-width:20px}#memo .company-info span{display:inline-block;min-width:20px}#memo:after{border-bottom:2px solid #000;content:'';display:block;clear:both}#invoice-info{float:right;margin:5px 0 0 20px}#invoice-info>div{float:right}#invoice-info>div>span{display:block;min-width:20px;min-height:18px;margin-bottom:3px}#invoice-info>div:last-child{margin-right:20px}#invoice-info:after{content:'';display:block;clear:both}#client-info{float:left;margin:5px 20px 0 0;min-width:220px;text-align:left}#client-info>div{margin-bottom:6px;min-width:20px}#client-info span{display:block;min-width:20px}#bill_to_label{font-weight:600;font-size:18px;margin-bottom:5px}#invoice-title-number{text-align:center;margin:20px 0}#invoice-title-number span{display:inline-block;min-width:20px}#invoice-title-number #title{margin-right:15px;text-align:right;font-size:20px;font-weight:700}#invoice-title-number #number{font-size:15px;text-align:left}#invoice-info  th{margin-right:3px;font-weight:650}#invoice-info  td{margin-left:3px;float:right}{-layout:fixed} td, th{vertical-align:top;word-break:keep-all;word-wrap:break-word;margin-bottom:10px}#items{margin:20px 0 35px 0}#items {border-collapse:separate;width:100%}#items  th{padding:12px 10px;text-align:left;background:#e6e7e7;border-bottom:4px solid rgba(200,211,211,.452)}#items  th:last-child{text-align:right;padding-right:20px!important}#items  tr{page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td{padding:5px 7px;text-align:left;border-right:1px solid #cccccf;border-bottom:1px solid rgba(200,211,211,.452);page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td:first-child{text-align:left;border-right:0!important}#items  td:last-child{text-align:right;border-right:0!important}#items  td:nth-child(2){text-align:left}#items  td:nth-child(5){text-align:right}#items  th:nth-child(1){width:20%!important}#items  th:nth-child(2){width:32%!important;text-align:left}#items  th:nth-child(3){width:13%!important}#items  th:nth-child(4){width:13%!important}#items  th:nth-child(5){width:7%!important}#items  th:nth-child(6){width:15%!important}#items  td:last-child{border-right:0!important;padding-right:20px!important}.currency{padding:0 10px 0 0}.currency span{font-size:11px;font-style:italic;color:#8b8b8b;display:inline-block;min-width:15px}#hr{bottom:200;border-bottom:2px solid #000;content:'';display:block;clear:both}#sums{position:relative;left:0;top:0;float:right;background:#f0f0f0;background-size:auto 100px;color:#000;font-size:16px;margin-top:inherit;page-break-before:auto;page-break-inside:avoid;page-break-after:avoid}#sums  tr td,#sums  tr th{padding:3px 10px 3px 10px;text-align:right}#sums  tr td dd{display:inline-block}#sums  tr th{text-align:left;padding-right:10px}#sums  tr td{width:200px auto!important;padding-right:10px}.payment-info{margin:0 20px}.payment-info div{font-size:18px;color:#8b8b8b;display:inline-block;min-width:20px}.ib_bottom_row_commands{margin:10px 0 0 20px!important}@media print{@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,700&subset=cyrillic,cyrillic-ext,latin,greek-ext,greek,latin-ext,vietnamese);a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h2,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;font-size:100%;vertical-align:baseline}html{line-height:1}ol,ul{list-style:none}#white{padding:3%;background-color:#fff}{border-collapse:collapse;border-spacing:0}caption,td,th{text-align:left;font-weight:400;vertical-align:middle}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}a img{border:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}.clearfix{display:block;clear:both}.hidden{display:none}.bold,b,strong{font-weight:700}#template_invoice{height:auto;overflow:auto;width:21cm;padding:.5cm;margin:.2cm auto;border:1px #d3d3d3 solid;border-radius:5px;background:#fff;box-shadow:0 0 5px rgba(0,0,0,.1);page-break-before:auto;page-break-inside:auto;page-break-after:auto}#container{font:normal 13px/1.4em 'Open Sans',Sans-serif;margin:5px 5px;padding:5px 5px;min-height:26cm;max-height:fit-content;height:fit-content;page-break-before:auto;page-break-inside:auto;page-break-after:auto}#memo .company-name{background:#fff 560px center no-repeat;background-size:100px auto;display:inline-block;margin-bottom:25px;padding:5px 0 5px 0}#memo .company-name span{color:#1dafec;display:inline-block;min-width:20px;font-size:75px;font-weight:700;line-height:1em}#memo .company-name .right-arrow{position:absolute;top:0;right:0;bottom:0;width:100px;background:right center no-repeat;background-size:auto 60px}#memo .logo{float:left;clear:left;margin-left:20px}#memo .logo img{width:150px;height:100px}#memo .company-info{float:right;text-align:right;display:inline-block;margin-left:20px;font-size:12px;color:#8b8b8b}#memo .company-info div{margin-bottom:5px;min-width:20px}#memo .company-info span{display:inline-block;min-width:20px}#memo:after{border-bottom:2px solid #000;content:'';display:block;clear:both}#invoice-info{float:right;margin:5px 0 0 20px}#invoice-info>div{float:right}#invoice-info>div>span{display:block;min-width:20px;min-height:18px;margin-bottom:3px}#invoice-info>div:last-child{margin-right:20px}#invoice-info:after{content:'';display:block;clear:both}#client-info{float:left;margin:5px 20px 0 0;min-width:220px;text-align:left}#client-info>div{margin-bottom:6px;min-width:20px}#client-info span{display:block;min-width:20px}#bill_to_label{font-weight:600;font-size:18px;margin-bottom:5px}#invoice-title-number{text-align:center;margin:20px 0}#invoice-title-number span{display:inline-block;min-width:20px}#invoice-title-number #title{margin-right:15px;text-align:right;font-size:20px;font-weight:700}#invoice-title-number #number{font-size:15px;text-align:left}#invoice-info  th{margin-right:3px;font-weight:650}#invoice-info  td{margin-left:3px;float:right}{-layout:fixed} td, th{vertical-align:top;word-break:keep-all;word-wrap:break-word;margin-bottom:10px}#items{margin:20px 0 35px 0}#items {border-collapse:separate;width:100%;page-break-before:auto;page-break-inside:auto;page-break-after:auto}#items  th{padding:12px 10px;text-align:left;background:#e6e7e7;border-bottom:4px solid rgba(200,211,211,.452)}#items  th:last-child{text-align:right;padding-right:20px!important}#items  tr{page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td{padding:5px 7px;text-align:left;border-right:1px solid #cccccf;border-bottom:1px solid rgba(200,211,211,.452);page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td:first-child{text-align:left;border-right:0!important}#items  td:last-child{text-align:right;border-right:0!important}#items  td:nth-child(2){text-align:left}#items  td:nth-child(5){text-align:right}#items  th:nth-child(1){width:20%!important}#items  th:nth-child(2){width:32%!important;text-align:left}#items  th:nth-child(3){width:13%!important}#items  th:nth-child(4){width:15%!important}#items  th:nth-child(5){width:7%!important}#items  th:nth-child(6){width:15%!important}#items  td:last-child{border-right:0!important;padding-right:20px!important}.currency{padding:0 10px 0 0}.currency span{font-size:11px;font-style:italic;color:#8b8b8b;display:inline-block;min-width:15px}#hr{bottom:200;border-bottom:2px solid #000;content:'';display:block;clear:both}#sums{position:relative;left:0;top:0;margin-top:inherit;float:right;background:#f0f0f0;background-size:auto 100px;color:#000;font-size:16px;page-break-before:auto;page-break-inside:avoid;page-break-after:avoid}#sums  tr td,#sums  tr th{padding:3px 10px 3px 10px;text-align:right;page-break-before:auto;page-break-inside:avoid;page-break-after:auto}#sums  tr td dd{display:inline-block}#sums  tr th{text-align:left;padding-right:10px}#sums  tr td{width:200px auto!important;padding-right:10px}.payment-info{margin:0 20px}.payment-info div{font-size:18px;color:#8b8b8b;display:inline-block;min-width:20px}.ib_bottom_row_commands{margin:10px 0 0 20px!important}.header{font-size:35px;text-align:center;font-weight:700;margin:0 0 20px 0;color:#3aabf0}.address{font-size:26px;display:flex;justify-content:space-between;margin:0 0 20px 0}.for p,.from p{font-size:26px;color:#787878}.from div,.from h3,.from span{font-size:26px;text-align:left}.for div,.for h3,.for span{text-align:left}.total_headings div{margin-left:80%}.signature{padding-top:36px}.currency_symbol{margin-left:0;text-align:left}.currency::before{content:'£  '}}.header{font-size:35px;text-align:center;font-weight:700;margin:0 0 20px 0;color:#3aabf0}.address{font-size:26px;display:flex;justify-content:space-between;margin:0 0 20px 0}.for p,.from p{font-size:26px;color:#787878}.from div,.from h3,.from span{font-size:26px;text-align:left}.for div,.for h3,.for span{text-align:left}.total_headings div{margin-left:80%}.signature{padding-top:36px}.currency_symbol{margin-left:0;text-align:left}.currency::before{content:'£  '}</style>";
    html += "</head>";
    html += "<div id='white'>"
    html += document.getElementById("template_invoice").innerHTML;
    html += "</div>";
    html += "</html>";
    var printWin = window.open('', '', 'left=0,top=0,toolbar=0,scrollbars=0,status  =0');
    printWin.document.write(html);
    printWin.document.close();
    printWin.focus();
    printWin.document.title = "";
    printWin.print();
    printWin.close();
  }
  breakDown(product_id) {
    this.break_down = true;
    this.reportingService.getProductBreakdown(product_id, 
      this.from, 
      this.to ).subscribe(data => {
      this.transactions = data["transactions"];
      this.product = data["product"][0];
    })

  }
  goBack() {
    this.break_down = false;

    this.reportingService.getProductsBySaleList(this.sort_by, 
      this.from, 
      this.to ).subscribe(data => {
      this.products = data;
    })
  }
  ngOnInit() {
    this.from.setDate(this.from.getDate());
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user ? user[0] : "";
      if (this.currentUser.user_type != 'admin') {
        this.store_id = this.currentUser.store_id;
        this.local.set("store_id", this.store_id, 0, 's');
      }
      else {
        this.store_id = (this.local.get("store_id") == "all") ? this.currentUser.store_id : this.local.get("store_id");
      }


    });
    var year = new Date().getFullYear();
    var range = [];
    // range.push(year);
    for (var i = 0; i < 10; i++) {
      range.push(year - i);
    }
    this.years = range;
    
    this.transactionService.getTodaysTransactionsCount(this.store_id, 
      this.from, 
      this.to ).toPromise().then(data => {
      this.todays_sales = data[0]["COUNT(*)"];
    });
    this.reportingService.getProductSalesReport({ "store_id": this.store_id, 
    "from": this.from, 
    "to": this.to }).subscribe(data => {
      this.summary_of_sales = data;
      console.log("Testing Testing");
      console.log(data);
      console.log((data["margin_pound"] / data["total_sales"]) * 100);
    });
    this.reportingService.getProductsBySale(
      this.from, 
      this.to ).subscribe(data => {
      this.products_by_sale = data;
    });
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.currentUserSubscription.unsubscribe();
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    if(type == "date_f") this.date_f = new Date(event.value);
    if(type == "from") this.from = new Date(event.value);
    if(type == "to") this.to = new Date(event.value);
    
  }
  dateChange(type, event) {
    // return;
    if(type == "from") this.from = new Date(event.value);
    if(type == "to") this.to = new Date(event.value);
    this.transactionService.getTodaysTransactionsCount(this.store_id,
      this.from, 
      this.to ).toPromise().then(data => {
      this.todays_sales = data[0]["COUNT(*)"];
    });
    this.reportingService.getProductSalesReport({ "store_id": this.store_id, 
    "from": this.from, 
    "to": this.to }).toPromise().then(data => {
      this.summary_of_sales = data;
    });

    this.reportingService.getProductsBySale(
      this.from, 
      this.to ).toPromise().then(data => {
      this.products_by_sale = data;
    });
  }
  marginsTransactions() {
    this.local.set("transactions_margin", { 
      "from" :this.from, 
      "to": this.to  });
    this.router.navigate(['/sales/transactions/' + this.from + "/" + this.to]);
  }

  search(event?) {
    this.date_f.setHours(12, 30);
    this.from.setHours(12, 30);
    this.to.setHours(12, 30);
    let period_value = (this.which_period == 'day') ? this.day :
      (this.which_period == 'date_f') ? this.date_f :
        (this.which_period == 'month') ? this.month :
          (this.which_period == 'year') ? this.year :
            (this.which_period == 'range') ? { 
      "from" :this.from, 
      "to": this.to  } : null;
    if (this.which_period == "day") {
      this.report_title = "Sales On Week Days";

      this.headings = [
        { 'name': 'Id', 'symbl': 't_id', 'checked': true, 'type': 'text' },
        { 'name': 'Day', 'symbl': 'day', 'checked': true, 'type': 'text' },
        { 'name': 'Date', 'symbl': 'date_day', 'checked': true, 'type': 'text' },
        { 'name': 'Type', 'symbl': 'type', 'checked': true, 'type': 'text' },
        { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
        { 'name': 'CustRef', 'symbl': 'customer_ref', 'checked': false, 'type': 'text' },
        { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales VAT', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales Gross', 'symbl': 'total', 'checked': true, 'type': 'number' },
        { 'name': 'Payment', 'symbl': 'payment', 'checked': true, 'type': 'number' },
        { 'name': 'Store', 'symbl': 'store_name', 'checked': false, 'type': 'text' },
        { 'name': 'Margin £', 'symbl': 'total_margin', 'checked': true, 'type': 'number' },
        { 'name': 'Margin %', 'symbl': 'total_percent_margin', 'checked': true, 'type': 'number' },
        { 'name': 'User Name', 'symbl': 'user_name', 'checked': false, 'type': 'text' },
        { 'name': 'Username', 'symbl': 'username', 'checked': false, 'type': 'text' },
        { 'name': 'Verified By', 'symbl': 'verified_by', 'checked': false, 'type': 'text' },
      ]
      this.reportingService.getSalesAndSummarybyDay().subscribe(data => {
        this.records = data["sales"];
      });
    }
    if (this.which_period == "date_f") {
      this.report_title = "Sales On Date"; // + period_value;
      this.headings = [
        { 'name': 'Id', 'symbl': 't_id', 'checked': true, 'type': 'text' },
        { 'name': 'Date', 'symbl': 'date_day', 'checked': true, 'type': 'text' },
        { 'name': 'Day', 'symbl': 'day', 'checked': true, 'type': 'text' },
        { 'name': 'Type', 'symbl': 'type', 'checked': true, 'type': 'text' },
        { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
        { 'name': 'CustRef', 'symbl': 'customer_ref', 'checked': false, 'type': 'text' },
        { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales VAT', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales Gross', 'symbl': 'total', 'checked': true, 'type': 'number' },
        { 'name': 'Payment', 'symbl': 'payment', 'checked': true, 'type': 'number' },
        { 'name': 'Store', 'symbl': 'store_name', 'checked': false, 'type': 'text' },
        { 'name': 'Margin £', 'symbl': 'total_margin', 'checked': true, 'type': 'number' },
        { 'name': 'Margin %', 'symbl': 'total_percent_margin', 'checked': true, 'type': 'number' },
        { 'name': 'User Name', 'symbl': 'user_name', 'checked': false, 'type': 'text' },
        { 'name': 'Username', 'symbl': 'username', 'checked': false, 'type': 'text' },
        { 'name': 'Verified By', 'symbl': 'verified_by', 'checked': false, 'type': 'text' },
      ]
      this.reportingService.getSalesAndSummarybyDate(period_value).subscribe(data => {
        this.records = data["sales"];
      });
    }
    if (this.which_period == "month") {
      this.report_title = "Sales Monthly Report";
      this.headings = [
        { 'name': 'Id', 'symbl': 't_id', 'checked': true, 'type': 'text' },
        { 'name': 'Date', 'symbl': 'date_day', 'checked': true, 'type': 'text' },
        { 'name': 'Month', 'symbl': 'day', 'checked': true, 'type': 'text' },
        { 'name': 'Type', 'symbl': 'type', 'checked': true, 'type': 'text' },
        { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
        { 'name': 'CustRef', 'symbl': 'customer_ref', 'checked': false, 'type': 'text' },
        { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales VAT', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales Gross', 'symbl': 'total', 'checked': true, 'type': 'number' },
        { 'name': 'Payment', 'symbl': 'payment', 'checked': true, 'type': 'number' },
        { 'name': 'Store', 'symbl': 'store_name', 'checked': false, 'type': 'text' },
        { 'name': 'Margin £', 'symbl': 'total_margin', 'checked': true, 'type': 'number' },
        { 'name': 'Margin %', 'symbl': 'total_percent_margin', 'checked': true, 'type': 'number' },
        { 'name': 'User Name', 'symbl': 'user_name', 'checked': false, 'type': 'text' },
        { 'name': 'Username', 'symbl': 'username', 'checked': false, 'type': 'text' },
        { 'name': 'Verified By', 'symbl': 'verified_by', 'checked': false, 'type': 'text' },
      ]
      this.reportingService.getSalesAndSummarybyMonth().subscribe(data => {

        this.records = data["sales"];
      });
    }
    if (this.which_period == "year") {
      this.report_title = "Sales Yearly Report";

      this.headings = [
        { 'name': 'Id', 'symbl': 't_id', 'checked': true, 'type': 'text' },
        { 'name': 'Date', 'symbl': 'date_day', 'checked': true, 'type': 'text' },
        { 'name': 'Year', 'symbl': 'day', 'checked': true, 'type': 'text' },
        { 'name': 'Type', 'symbl': 'type', 'checked': true, 'type': 'text' },
        { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
        { 'name': 'CustRef', 'symbl': 'customer_ref', 'checked': false, 'type': 'text' },
        { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales VAT', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales Gross', 'symbl': 'total', 'checked': true, 'type': 'number' },
        { 'name': 'Payment', 'symbl': 'payment', 'checked': true, 'type': 'number' },
        { 'name': 'Store', 'symbl': 'store_name', 'checked': false, 'type': 'text' },
        { 'name': 'Margin £', 'symbl': 'total_margin', 'checked': true, 'type': 'number' },
        { 'name': 'Margin %', 'symbl': 'total_percent_margin', 'checked': true, 'type': 'number' },
        { 'name': 'User Name', 'symbl': 'user_name', 'checked': false, 'type': 'text' },
        { 'name': 'Username', 'symbl': 'username', 'checked': false, 'type': 'text' },
        { 'name': 'Verified By', 'symbl': 'verified_by', 'checked': false, 'type': 'text' },
      ]
      this.reportingService.getSalesAndSummarybyYear().subscribe(data => {
        this.records = data["sales"];
      });
    }
    if (this.which_period == "range") {
      this.report_title = "Sales Report By Date Range";
      this.report_from = this.from;
      this.report_to = this.to;
      this.headings = [
        { 'name': 'Id', 'symbl': 't_id', 'checked': true, 'type': 'text' },
        { 'name': 'Date', 'symbl': 'date_day', 'checked': true, 'type': 'text' },
        // { 'name': 'Year', 'symbl': 'day', 'checked': true, 'type': 'text' },
        { 'name': 'Type', 'symbl': 'type', 'checked': true, 'type': 'text' },
        { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
        { 'name': 'CustRef', 'symbl': 'customer_ref', 'checked': false, 'type': 'text' },
        { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales VAT', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
        { 'name': 'Sales Gross', 'symbl': 'total', 'checked': true, 'type': 'number' },
        { 'name': 'Payment', 'symbl': 'payment', 'checked': true, 'type': 'number' },
        { 'name': 'Store', 'symbl': 'store_name', 'checked': false, 'type': 'text' },
        { 'name': 'Margin £', 'symbl': 'total_margin', 'checked': true, 'type': 'number' },
        { 'name': 'Margin %', 'symbl': 'total_percent_margin', 'checked': true, 'type': 'number' },
        { 'name': 'User Name', 'symbl': 'user_name', 'checked': false, 'type': 'text' },
        { 'name': 'Username', 'symbl': 'username', 'checked': false, 'type': 'text' },
        { 'name': 'Verified By', 'symbl': 'verified_by', 'checked': false, 'type': 'text' },
      ]
      this.reportingService.getSalesAndSummarybyRange(
        this.from, 
        this.to ).subscribe(data => {
        this.records = data["sales"];
      });
    }
  }
  customerAndProduct(period?) {
    this.report_title = "Sales Report By Customers & Products";
    this.headings = [
      { 'name': 'CustId', 'symbl': 'customer_id', 'checked': false, 'type': 'text' },
      { 'name': 'Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
      { 'name': 'SKU', 'symbl': 'sku', 'checked': true, 'type': 'text' },
      { 'name': 'Product Name', 'symbl': 'product_name', 'checked': true, 'type': 'product_name' },
      { 'name': 'Qty', 'symbl': 'quantity_sold', 'checked': true, 'type': 'text' },
      { 'name': 'Sales Net', 'symbl': 'net_value', 'checked': true, 'type': 'number' },
      { 'name': 'Sales VAT', 'symbl': 'vat_value', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Gross', 'symbl': 'gross_value', 'checked': true, 'type': 'number' },
      { 'name': 'Margin £', 'symbl': 'margin', 'checked': true, 'type': 'number' },
      { 'name': 'Margin %', 'symbl': 'margin_percent', 'checked': true, 'type': 'number' },
    ]
    this.reportingService.getSalesAndSummaryCustomerAndProduct().subscribe(data => {
      this.records = data["sales"];
      this.summary = data["summary"][0];
    });
  }
  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line != '') line += ','

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
  exportProducts() {
    let csvData;
    this.productsService.exportProducts(this.store_id).subscribe(data => {
      csvData = this.ConvertToCSV(this.records);
      var a = document.createElement("a");
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      var blob = new Blob([csvData], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'Report.csv';
      a.click();
    });
  }
  print(event) {
  }
  csr() {
    this.report_title = "Sales Report By Customers";
    this.headings = [
      { 'name': 'CustId', 'symbl': 'customer_id', 'checked': false, 'type': 'text' },
      { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
      { 'name': 'Credit Limit', 'symbl': 'credit_limit', 'checked': true, 'type': 'number' },
      { 'name': 'Purchase', 'symbl': 'current_credit', 'checked': true, 'type': 'number' },
      { 'name': 'Cost', 'symbl': 'buying_value', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Vat', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Gross', 'symbl': 'gross_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Margin £', 'symbl': 'margin_£', 'checked': true, 'type': 'number' },
      { 'name': 'Margin %', 'symbl': 'margin_%', 'checked': true, 'type': 'number' }
    ]
    this.reportingService.getCustomerSalesReport().subscribe(data => {
      this.records = data["sales"];
      this.summary = data["summary"][0];
    });

  }
  gotoRoute(data) {
    this.local.set('customer_transactions', { "customer": data, "from": this.csr_from, "to": this.csr_to, "period": 1, "which_period": "range" });

    this.router.navigate(['/reporting/']);
  }
  searchCSR() {
    this.report_title = "Sales Report By Customers";
    this.headings = [
      { 'name': 'CustId', 'symbl': 'customer_id', 'checked': false, 'type': 'text' },
      { 'name': 'Customer Name', 'symbl': 'customer_name', 'checked': true, 'type': 'text' },
      { 'name': 'Credit Limit', 'symbl': 'credit_limit', 'checked': true, 'type': 'number' },
      { 'name': 'Purchase', 'symbl': 'current_credit', 'checked': true, 'type': 'number' },
      { 'name': 'Cost', 'symbl': 'buying_value', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Vat', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Gross', 'symbl': 'gross_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Margin £', 'symbl': 'margin_£', 'checked': true, 'type': 'number' },
      { 'name': 'Margin %', 'symbl': 'margin_%', 'checked': true, 'type': 'number' }
    ];
    this.reportingService.getCustomerSalesReport({ "from": this.csr_from, "to": this.csr_to, "sort_by": this.sort_by, "order_by": this.order_by }).subscribe(data => {
      this.records = data["sales"];
      this.summary = data["summary"][0];
    });
  }
  cpr() {
    let csvData;
    this.reportingService.getCustomerSalesReport().subscribe(data => {
      csvData = this.ConvertToCSV(data);
      var a = document.createElement("a");
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      var blob = new Blob([csvData], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'Report.csv';
      a.click();
    });
  }
  rsr() {
    this.report_title = "Sales Report By Representative";
    this.headings = [
      { 'name': 'User Id', 'symbl': 'user_id', 'checked': false, 'type': 'text' },
      { 'name': 'Username', 'symbl': 'user_name', 'checked': true, 'type': 'text' },
      // {'name': 'Transaction Date' , 'symbl':'transaction_date', 'checked': true},
      { 'name': 'Cost', 'symbl': 'buying_value', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Vat', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Gross', 'symbl': 'gross_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Margin £', 'symbl': 'margin_£', 'checked': true, 'type': 'number' },
      { 'name': 'Margin %', 'symbl': 'margin_%', 'checked': true, 'type': 'number' }
    ]
    this.reportingService.getRepresentativeSalesReport().subscribe(data => {
      this.records = data["sales"];
      this.summary = data["summary"][0];
    });
  }
  cmr() {

  }
  psr() {
    this.products_report = 1;
  }
  search_psr() {

    this.report_title = "Sales Report By Products";
    this.headings = [
      { 'name': 'Product Id', 'symbl': 'product_id', 'checked': false, 'type': 'text' },
      { 'name': 'SKU', 'symbl': 'sku', 'checked': true, 'type': 'text' },
      { 'name': 'Product Name', 'symbl': 'product_name', 'checked': true, 'type': 'product_name' },
      { 'name': 'Quantity Sold', 'symbl': 'quantity_sold', 'checked': true, 'type': 'text' },
      // { 'name': 'Cost Per Piece', 'symbl': 'cost_at_time', 'checked': true, 'type': 'number' },
      { 'name': 'Cost', 'symbl': 'buying_value', 'checked': true, 'type': 'number' },
      // { 'name': 'Sales Net', 'symbl': 'net_amount', 'checked': true, 'type': 'number' },
      // { 'name': 'Sales Vat', 'symbl': 'vat_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Sales Gross', 'symbl': 'gross_amount', 'checked': true, 'type': 'number' },
      { 'name': 'Margin £', 'symbl': 'margin', 'checked': true, 'type': 'number' },
      { 'name': 'Margin %', 'symbl': 'percent_margin', 'checked': true, 'type': 'number' }
    ]
    this.reportingService.getProductSalesReport({ "store_id": this.store_id, 
    "from": this.from, 
    "to" : this.to , "sort_by": this.sort_by }).subscribe(data => {
      // this.records = data["sales"];
      // this.summary = data["summary"][0];
      this.records = data;

    });

  }
  tsr() {

  }
  print_report(div_id) {
    var data = document.getElementById("csr").innerHTML;
    var html = "<html>";
    html += "<head>";
    html += "<style>@media print{@page{size:auto;size: A4 portrait;margin-top: 2%;margin-bottom: 4%;margin-left: 0%;margin-right: 0%;border: 1px solid red;orphans:5; widows:4;}@page :nth(2) body{orphans:5; widows:4;margin-top:5%;th.product_name{width:25%}}</style>"
    html += "<style>body{font-family:monospace};table{border-collapse:collapse;width:100%}th{text-align:left;padding:1px;width:min-content}td{text-align:left;padding:4px;width:fit-content}tr:nth-child(even){background-color:#f2f2f2}.amount{text-align:right}th.product_name{width:25%}</style>";
    html += "<style>@page :left {@bottom-left {content: counter(page);}</style>"
    html += "<style>#container{font:normal 13px/1.4em 'Open Sans',Sans-serif;margin:5px 5px;padding:5px 5px;min-height:26cm;max-height:fit-content;height:fit-content;page-break-before:auto;page-break-inside:auto;page-break-after:auto}#sums{position:relative;left:0;top:0;float:right;background:#f0f0f0;background-size:auto 100px;color:#000;font-size:16px;margin-top:inherit;page-break-before:auto;page-break-inside:avoid;page-break-after:avoid}#sums table tr td,#sums table tr th{padding:3px 10px 3px 10px;text-align:right}#sums table tr td dd{display:inline-block}#sums table tr th{text-align:left;padding-right:10px}#sums table tr td{width:200px auto!important;padding-right:10px}</style>"
    html += "</head>";
    html += "<body>";
    html += document.getElementById("summary").innerHTML;
    html += "<div id='white'>"
    html += document.getElementById("csr").innerHTML;
    html += "</div>";
    html += "</body>";
    html += "</html>";
    var printWin = window.open('', '', 'left=0,top=0,toolbar=0,scrollbars=0,status  =0');
    printWin.document.write(html);
    printWin.document.close();
    printWin.focus();
    printWin.document.title = "";
    printWin.print();
  }
  opendashboardProductsDialog(sort_by) {
    this.sort_by = sort_by;
    this.dialogOpened = true;

    this.reportingService.getProductsBySaleList(sort_by, 
      this.from, 
      this.to ).subscribe(data => {
      this.products = data;
    })
  }
  exportSales = function(){
    let csvData;
    this.transactionService.exportSales(this.store_id, 
      this.from, 
      this.to ).subscribe(data => {
      csvData = this.ConvertToCSV(data);
      var a = document.createElement("a");
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      var blob = new Blob([csvData], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'Sales.csv';
      a.click();
    });
  }
}
